import axios, { type AxiosInstance } from 'axios';

interface RestClientInstance extends AxiosInstance {
  getCsrfToken(): (typeof axios.defaults.headers.common)['X-CSRF-Token'];
  getCorrelationId(): (typeof axios.defaults.headers.common)['X-Correlation-ID'];
}
const RestClient = axios.create() as RestClientInstance;

RestClient.getCsrfToken = () => RestClient.defaults.headers.common['X-CSRF-Token'];
RestClient.getCorrelationId = () => RestClient.defaults.headers.common['X-Correlation-ID'];

export default RestClient;
